/**
 * Shopify Ajax POST /cart/add.js now expects { items: [{ id, quantity, ... }] }.
 * Theme (layout.theme.js) still sends legacy { id, quantity, properties, selling_plan }.
 * This normalizes JSON bodies on fetch + XMLHttpRequest so add-to-cart works.
 *
 * Subscribe / pick-plan: theme historically read selling_plan with jQuery .val() on radios
 * (always the first plan). We prefer the active form's checked selling_plan + variant select.
 */
(function () {
  'use strict';

  function isCartAddUrl(url) {
    if (!url) return false;
    var s = String(url);
    return s.indexOf('cart/add') !== -1;
  }

  /**
   * Dual pick-plan: use the visible panel's form first (do not require data-bp-primary-subscribe-form).
   * Otherwise the first [data-bp-primary-subscribe-form] on the page can be the wrong/hidden panel.
   */
  function getSubscribeProductForm() {
    var dualRoot = document.querySelector('[data-pick-plan-product-root][data-pick-plan-dual="true"]');
    if (dualRoot) {
      var ap = dualRoot.querySelector('[data-bp-pick-plan-panel-active="true"]');
      var f = ap && ap.querySelector('form[data-product-form]');
      if (f) return f;
    }
    var primary = document.querySelector('[data-bp-primary-subscribe-form]');
    if (primary) {
      var f2 = primary.querySelector('form[data-product-form]');
      if (f2) return f2;
    }
    return null;
  }

  function isPurchaseAsOnetime(form) {
    if (!form) return false;
    var cb = null;
    var dualRoot = form.closest('[data-pick-plan-product-root]');
    if (dualRoot && dualRoot.querySelector('[data-bp-dual-subscription-panels]')) {
      var fs = dualRoot.querySelector('[data-bp-frequency-fieldset]:not([disabled])');
      cb = fs && fs.querySelector('[data-bp-add-as-onetime]:checked');
    }
    if (!cb) {
      var cards = form.querySelector('[data-frequency-cards]');
      cb = cards && cards.querySelector('[data-bp-add-as-onetime]:checked');
    }
    if (!cb) cb = form.querySelector('[data-bp-add-as-onetime]:checked');
    if (cb) return true;
    if (form.getAttribute('data-bp-purchase-as-onetime') === 'true') return true;
    var po = form.querySelector('input[name="purchase_option"]:checked');
    return !!(po && po.value === 'one-time');
  }

  function getActiveSellingPlanRadio(form) {
    if (!form) return null;
    if (window.__bpResolveActiveSellingPlanRadio) {
      return window.__bpResolveActiveSellingPlanRadio(form, form.closest('[data-pick-plan-product-root]'));
    }
    var dualRoot = form.closest('[data-pick-plan-product-root]');
    if (dualRoot && dualRoot.querySelector('[data-bp-dual-subscription-panels]')) {
      var fs = dualRoot.querySelector('[data-bp-frequency-fieldset]:not([disabled])');
      return fs ? fs.querySelector('input[name="selling_plan"]:checked') : null;
    }
    return form.querySelector('input[name="selling_plan"]:checked');
  }

  function resolveVariantIdFromDom() {
    var form = getSubscribeProductForm() || document.querySelector('[data-product-form]');
    var sel = form ? form.querySelector('select[name="id"]') : null;
    if (!sel) sel = document.querySelector('select[name="id"]');
    if (!sel || sel.value == null || sel.value === '') return null;
    var n = Number(sel.value);
    return isNaN(n) ? null : n;
  }

  /** Match theme pack labels — align with pick-plan-product-layout packCountFromOptionText. */
  function packCountFromVariantOption(text) {
    var t = String(text || '').trim().toLowerCase();
    var onlyNum = t.match(/^(\d+)$/);
    if (onlyNum) return parseInt(onlyNum[1], 10);
    var m =
      t.match(/^(\d+)\s*[-]?\s*pack\b/) ||
      t.match(/^(\d+)\s*pk\b/) ||
      t.match(/\bpack\s*[-]?\s*(\d+)\b/) ||
      t.match(/^(\d+)\s*pack/) ||
      t.match(/^(\d+)\s*[-]?\s*pads?\b/) ||
      t.match(/\bpads?\s*[-]?\s*(\d+)\b/) ||
      t.match(/^(\d+)\s*pads?\b/);
    return m ? parseInt(m[1], 10) : NaN;
  }

  function resolveVariantIdFromPackCountAndProductJson(data, packCount) {
    var variants = data.product && data.product.variants;
    if (!variants || !variants.length) return null;
    var i;
    for (i = 0; i < variants.length; i++) {
      var v = variants[i];
      var o1 = packCountFromVariantOption(v.option1);
      var o2 = packCountFromVariantOption(v.option2);
      var o3 = packCountFromVariantOption(v.option3);
      var ot = packCountFromVariantOption(v.title);
      if (o1 === packCount || o2 === packCount || o3 === packCount || ot === packCount) {
        return Number(v.id);
      }
    }
    var owv = data.options_with_values;
    if (owv && owv.length === 1 && packCount >= 1) {
      var opt = owv[0];
      var vals = opt.values;
      var pos = opt.position || 1;
      var key = 'option' + pos;
      if (vals && vals.length >= packCount) {
        var targetVal = vals[packCount - 1];
        for (i = 0; i < variants.length; i++) {
          var vj = variants[i];
          if (vj[key] === targetVal) return Number(vj.id);
        }
      }
    }
    return null;
  }

  /**
   * Vue :value on hidden variant <select> often stays on first option; frequency card data-quantity + JSON is authoritative.
   */
  function resolveVariantIdFromFrequencyAndJson(form) {
    if (!form) return null;
    var rad = getActiveSellingPlanRadio(form);
    if (!rad || rad.value === '' || rad.hasAttribute('data-radio-onetime')) return null;
    var lineVid = rad.getAttribute('data-bp-line-variant-id');
    if (lineVid) {
      var lineN = Number(String(lineVid).trim());
      if (!isNaN(lineN) && lineN > 0) return lineN;
    }
    if (isPurchaseAsOnetime(form)) return null;
    var packCount = parseInt(rad.getAttribute('data-quantity'), 10);
    if (isNaN(packCount) || packCount < 1) return null;

    var jsonEl = null;
    var panel = form.closest('.pick-plan-product-panel');
    if (panel) jsonEl = panel.querySelector('script[data-product-json]');
    if (!jsonEl) {
      var walk = form;
      while (walk && walk !== document.documentElement) {
        jsonEl = walk.querySelector('script[data-product-json]');
        if (jsonEl) break;
        walk = walk.parentElement;
      }
    }
    if (!jsonEl || !jsonEl.textContent.trim()) return null;

    try {
      var data = JSON.parse(jsonEl.textContent);
      return resolveVariantIdFromPackCountAndProductJson(data, packCount);
    } catch (e) {}
    return null;
  }

  /**
   * @returns {number|false|undefined} numeric selling plan id, false = one-time, undefined = unknown
   */
  function resolveSellingPlanFromForm(form) {
    if (!form) return undefined;
    if (isPurchaseAsOnetime(form)) return false;
    var rad = getActiveSellingPlanRadio(form);
    if (rad && rad.value !== '' && !rad.hasAttribute('data-radio-onetime')) {
      var n = parseInt(rad.value, 10);
      return isNaN(n) ? undefined : n;
    }
    var sel = form.querySelector('select[name="selling_plan"]');
    if (sel && sel.value !== '') {
      var n2 = parseInt(sel.value, 10);
      return isNaN(n2) ? undefined : n2;
    }
    return undefined;
  }

  function applySubscribeVariantAndPlanToItem(item, subscribeForm) {
    var preferDom = !!subscribeForm;
    var freqVid = preferDom ? resolveVariantIdFromFrequencyAndJson(subscribeForm) : null;
    var domVid = resolveVariantIdFromDom();
    var domSp = preferDom ? resolveSellingPlanFromForm(subscribeForm) : undefined;

    var baseId = item.id != null ? item.id : item.variant_id;
    var id = baseId;
    if (preferDom && freqVid != null) {
      id = freqVid;
    } else if (preferDom && domVid != null) {
      id = domVid;
    } else if (id == null || id === '') {
      id = domVid;
    }
    if (id == null || id === '') return null;

    var next = Object.assign({}, item, { id: Number(id) });
    if ('variant_id' in next) delete next.variant_id;

    if (domSp === false) {
      delete next.selling_plan;
    } else if (typeof domSp === 'number' && !isNaN(domSp)) {
      next.selling_plan = domSp;
    }

    return next;
  }

  function toItemsPayload(data) {
    if (!data || typeof data !== 'object') return null;

    var subscribeForm = getSubscribeProductForm();

    if (data.items && Array.isArray(data.items)) {
      if (data.items.length !== 1) return null;
      var patched = applySubscribeVariantAndPlanToItem(data.items[0], subscribeForm);
      if (!patched) return null;
      return { items: [patched] };
    }

    var preferDom = !!subscribeForm;
    var freqVid = preferDom ? resolveVariantIdFromFrequencyAndJson(subscribeForm) : null;
    var domVid = resolveVariantIdFromDom();

    var id = data.id != null ? data.id : data.variantId;
    if (preferDom && freqVid != null) {
      id = freqVid;
    } else if (preferDom && domVid != null) {
      id = domVid;
    } else if (id == null || id === '') {
      id = domVid;
    }
    if (id == null || id === '') return null;

    var item = {
      id: Number(id),
      quantity: Math.max(1, parseInt(data.quantity, 10) || 1)
    };
    if (data.properties && typeof data.properties === 'object' && Object.keys(data.properties).length) {
      item.properties = data.properties;
    }

    var sp = data.selling_plan;
    var domSp = preferDom ? resolveSellingPlanFromForm(subscribeForm) : undefined;

    if (domSp === false) {
      /* one-time: do not send selling_plan */
    } else if (typeof domSp === 'number' && !isNaN(domSp)) {
      item.selling_plan = domSp;
    } else if (sp != null && sp !== '' && !isNaN(Number(sp))) {
      item.selling_plan = Number(sp);
    }

    return { items: [item] };
  }

  function normalizeJsonBody(bodyStr, url) {
    if (!bodyStr || typeof bodyStr !== 'string') return bodyStr;
    if (!isCartAddUrl(url)) return bodyStr;
    try {
      var data = JSON.parse(bodyStr);
      var next = toItemsPayload(data);
      if (next) return JSON.stringify(next);
    } catch (e) {}
    return bodyStr;
  }

  if (typeof window.fetch === 'function') {
    var origFetch = window.fetch;
    window.fetch = function (url, opts) {
      opts = opts || {};
      var u = typeof url === 'string' ? url : url && url.url ? url.url : '';
      if (opts.body && typeof opts.body === 'string') {
        var nb = normalizeJsonBody(opts.body, u);
        if (nb !== opts.body) opts = Object.assign({}, opts, { body: nb });
      }
      return origFetch.call(this, url, opts);
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__bpCartUrl = url;
    return origOpen.apply(this, arguments);
  };

  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (body) {
    if (body && typeof body === 'string') {
      var nb = normalizeJsonBody(body, this.__bpCartUrl || '');
      if (nb !== body) body = nb;
    }
    return origSend.call(this, body);
  };
})();
